var map = {
	"./2010/People/error.json": 91772,
	"./2011/People/error.json": 12853,
	"./2012/People/organizers.json": 87010,
	"./2012/People/session-chairs.json": 56465,
	"./2012/People/speakers.json": 22194,
	"./2012/Program/program.json": 20131,
	"./2013/People/organizers.json": 64009,
	"./2013/People/session-chairs.json": 31014,
	"./2013/People/speakers.json": 77317,
	"./2013/Program/program.json": 37792,
	"./2014/People/organizers.json": 42192,
	"./2014/People/session-chairs.json": 32083,
	"./2014/People/speakers.json": 35212,
	"./2014/Program/program.json": 37113,
	"./2015/People/organizers.json": 70351,
	"./2015/People/session-chairs.json": 59680,
	"./2015/People/speakers.json": 82103,
	"./2015/Program/program.json": 80398,
	"./2016/People/organizers.json": 38782,
	"./2016/People/session-chairs.json": 845,
	"./2016/People/speakers.json": 82782,
	"./2016/Program/program.json": 67775,
	"./2017/People/organizers.json": 30853,
	"./2017/People/session-chairs.json": 40546,
	"./2017/People/speakers.json": 59713,
	"./2017/Program/program.json": 27756,
	"./2018/People/organizers.json": 84332,
	"./2018/People/session-chairs.json": 62319,
	"./2018/People/speakers.json": 75976,
	"./2018/Program/program.json": 45781,
	"./2019/People/organizers.json": 92267,
	"./2019/People/session-chairs.json": 91276,
	"./2019/People/speakers.json": 39843,
	"./2019/Program/program.json": 23098,
	"./2020/People/organizers.json": 29623,
	"./2020/People/session-chairs.json": 53768,
	"./2020/People/speakers.json": 73039,
	"./2020/Program/program.json": 29782,
	"./2021/People/organizers.json": 45976,
	"./2021/People/session-chairs.json": 78715,
	"./2021/People/speakers.json": 53092,
	"./2021/Program/program.json": 58945,
	"./2022/People/error.json": 79175,
	"./2022/People/organizers.json": 11693,
	"./2022/People/session-chairs.json": 30090,
	"./2022/People/speakers.json": 43545,
	"./2022/Program/program.json": 84212,
	"./2023/Masterclass/links.json": 6316,
	"./2023/People/organizers.json": 8838,
	"./2023/People/session-chairs.json": 8885,
	"./2023/People/speakers.json": 71542,
	"./2023/Program/program.json": 74343,
	"./2023/Registration/fees.json": 95691,
	"./2023/Venue/hotels.json": 66671,
	"./2024/Masterclass/links.json": 3193,
	"./2024/People/organizers.json": 54939,
	"./2024/People/session-chairs.json": 6364,
	"./2024/People/speakers.json": 12723,
	"./2024/Program/program.json": 80650,
	"./2024/Registration/events-reduced.json": 23225,
	"./2024/Registration/events.json": 19002,
	"./2025/Masterclass/links.json": 37538,
	"./2025/People/organizers.json": 58652,
	"./2025/People/session-chairs.json": 49887,
	"./2025/People/speakers.json": 97432,
	"./2025/Program/program.json": 61669,
	"./2025/Registration/abbreviations.json": 55021,
	"./2025/Registration/discounts.json": 34532,
	"./2025/Registration/events-reduced.json": 2834,
	"./2025/Registration/events.json": 48641,
	"./2025/keyDates.json": 65182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7069;